import usePaymentOverdueBannerEligibility from "components/Banners/PaymentOverdueBanner/usePaymentOverdueBannerEligibility";
import useUpcomingRenewalBanner from "components/Banners/UpcomingRenewalBanner/useUpcomingRenewalBanner";
import useLaunchBannerEligibility from "components/Banners/LaunchBanner/useLaunchBannerEligibility";
import useHyroxConditioningTestBannerEligibility from "components/Banners/HyroxConditioningTestBanner/useHyroxConditioningTestBannerEligibility";
import useHyroxOutputTiersBannerEligibility from "components/Banners/HyroxOutputTiersBanner/useHyroxOutputTiersBannerEligibility";
import useRemoteAnnouncementMessage from "components/Banners/RemoteAnnouncementBanner/useRemoteAnnouncementMessage";
import useSubscriptionInTrial from "hooks/useSubscriptionInTrial";
import useFeatureFlagStatus from "providers/FeatureFlagProvider/useFeatureFlagStatus";
import { BannerPriority, Banner } from "components/Banners/Banners.config";
import type { BannerId } from "components/Banners/Banners.config";

function useActiveBannerId(): BannerId | null {
  const featureFlagStatus = useFeatureFlagStatus();
  const announcement = useRemoteAnnouncementMessage();

  const eligibility: Record<BannerId, boolean> = {
    [Banner.RemoteAnnouncementBanner]: Boolean(announcement.message),
    [Banner.SubscriptionPastDueBanner]: usePaymentOverdueBannerEligibility(),
    [Banner.SubscriptionUpcomingRenewalBanner]: useUpcomingRenewalBanner().isEligible,
    [Banner.SubscriptionTrialBanner]: useSubscriptionInTrial(),
    [Banner.LaunchBanner]: useLaunchBannerEligibility(),
    [Banner.HyroxConditioningTestBanner]: useHyroxConditioningTestBannerEligibility(),
    [Banner.HyroxOutputTiersBanner]: useHyroxOutputTiersBannerEligibility(),
  };

  // The banners' async inputs both settle once, at page load
  if (featureFlagStatus === "fetching") return null;
  if (announcement.status === "fetching") return null;

  return BannerPriority.find((bannerId) => eligibility[bannerId]) ?? null;
}

export default useActiveBannerId;
